import {
  useFileCollection,
  useFilesFromFileCollectionId,
} from '@witmetrics/data-store';
import { mapToId, sortAlphabeticalByName } from '@witmetrics/utils/arrays';
import { isEmpty } from '@witmetrics/utils/misc';
import { FileItem } from '@/components/FileCollection';
import { classes } from './utils';

export type CollectionSelectorListItemProps = {
  fileCollectionId: number;
  openFileIds: number[];
  onToggleFileId: (id: number) => void;
  onOpenCollection: (ids: number[]) => void;
  onCloseCollection: (ids: number[]) => void;
};

export default function CollectionSelectorListItem({
  fileCollectionId,
  openFileIds,
  onToggleFileId,
  onOpenCollection,
  onCloseCollection,
}: CollectionSelectorListItemProps) {
  const fileCollection = useFileCollection(fileCollectionId);
  const files = useFilesFromFileCollectionId(fileCollectionId);

  const fileIds = mapToId(files);
  const isAllOpen =
    !isEmpty(files) && fileIds.every((id) => openFileIds.includes(id));

  const handleToggleAll = () => {
    if (isAllOpen) {
      onCloseCollection(fileIds);
    } else {
      onOpenCollection(fileIds);
    }
  };

  if (!fileCollection) return null;

  return (
    <li className={classes.wrapper}>
      <div className={classes.header}>
        <div className={classes.sectionLabel}>{fileCollection.name}</div>
        {!isEmpty(files) && (
          <button
            className={classes.toggleAllButton}
            type="button"
            onClick={handleToggleAll}>
            {isAllOpen ? 'Clear' : 'Select all'}
          </button>
        )}
      </div>
      <ul className={classes.list}>
        {sortAlphabeticalByName(files).map(({ id }) => (
          <li key={id}>
            <FileItem
              dense
              active={openFileIds.includes(id)}
              fileId={id}
              onSelect={onToggleFileId}
            />
          </li>
        ))}
      </ul>
    </li>
  );
}
